// Unpublished Work © 2020-2026 Deere & Company.

import equipmentTiles from 'Ui/components/common/tile-constants/tiles/equipment';
import fertChemTiles from 'Ui/components/common/tile-constants/tiles/fert-chem';
import homeTiles from 'Ui/components/common/tile-constants/tiles/home';
import laborTiles from 'Ui/components/common/tile-constants/tiles/labor';
import roundsTiles from 'Ui/components/common/tile-constants/tiles/rounds';
import waterEnergyTiles from 'Ui/components/common/tile-constants/tiles/water-energy';
import weatherCourseTiles from 'Ui/components/common/tile-constants/tiles/weather-course';

const tileInfo = Object.assign({},
    equipmentTiles,
    fertChemTiles,
    homeTiles,
    laborTiles,
    roundsTiles,
    waterEnergyTiles,
    weatherCourseTiles
);

function getTileInfo(tileId, isgToggles) {
    const tileInfoForTileId = tileInfo[tileId];
    const toggleVariant = Object.entries(tileInfoForTileId?.toggleVariants || {})
        .find(([toggle]) => isgToggles?.[toggle]);

    return toggleVariant ? {
        ...tileInfoForTileId,
        ...toggleVariant[1]
    } : tileInfoForTileId;
}

export {
    getTileInfo
};

export default tileInfo;
